import { useState, useEffect } from "react";

const useDraftSolutionDetail = ({ open, draft }) => {
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        if (open) {
            setActiveTab(0);
        }
    }, [open, draft]);

    const handleTabChange = (_, newValue) => {
        setActiveTab(newValue);
    };

    return {
        activeTab,
        handleTabChange,
    };
};

export default useDraftSolutionDetail;